export default "__VITE_ASSET__DS0rjA6f__"